import { render } from "./SocialMediaPage.vue?vue&type=template&id=3f9fc112&ts=true"
import script from "./SocialMediaPage.vue?vue&type=script&lang=ts"
export * from "./SocialMediaPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__